
import { createRoot } from 'react-dom/client';

import ReviewsFrontEnd from './ReviewsFrontEnd';
import Style from './Style';
import './style.scss';

// Business Review
document.addEventListener('DOMContentLoaded', () => {
	const allBlockDirectory = document.querySelectorAll('.wp-block-grbb-business-review');
	allBlockDirectory.forEach(reviews => {
		const attributes = JSON.parse(reviews.dataset.attributes);

		createRoot(reviews).render(<>
			<Style attributes={attributes} clientId={attributes.cId} />
			<ReviewsFrontEnd attributes={attributes} isBackend={false} clientId={attributes.cId} />
		</>);

		reviews?.removeAttribute('data-attributes');
	});
});